<div class="grid grid-cols-3 gap-4 only:[&>*]:col-start-3">
  @if(onlyDocumentsMode){
  <ng-container *ngTemplateOutlet="documents"></ng-container>
  } @else { @switch (status) { @case ('control') {
  <button
    mat-flat-button
    type="button"
    color="primary"
    [disabled]="disabledActions || !showApprove"
    (click)="handleTransitionToApproved($event)"
  >
    <mat-icon>check</mat-icon>Aprobar
  </button>
  <button
    mat-flat-button
    type="button"
    color="warn"
    [disabled]="disabledActions || !showReject"
    (click)="handleTransitionToRejected($event)"
  >
    <mat-icon>clear</mat-icon>Rechazar
  </button>
  <ng-container *ngTemplateOutlet="documents"></ng-container>

  } @case ('approved') {
  <button
    mat-flat-button
    type="button"
    color="primary"
    [disabled]="disabledActions || !showProduce"
    (click)="handleTransitionToProduced($event)"
  >
    <mat-icon>check</mat-icon>Producir
  </button>
  <ng-container *ngTemplateOutlet="cancel"></ng-container>
  <ng-container *ngTemplateOutlet="documents"></ng-container>

  } @case ('produced') {
  <button
    mat-flat-button
    type="button"
    color="primary"
    [disabled]="disabledActions || !showIssue"
    (click)="handleTransitionToIssued($event)"
  >
    <mat-icon>check</mat-icon>Expedir
  </button>
  <ng-container *ngTemplateOutlet="cancel"></ng-container>
  <ng-container *ngTemplateOutlet="documents"></ng-container>
  } @case('issued') {
  <button
    mat-flat-button
    type="button"
    color="accent"
    [disabled]="disabledActions || !showDeliver"
    (click)="handleTransitionToDelivered($event)"
  >
    <mat-icon>check</mat-icon>Entregar
  </button>
  <ng-container *ngTemplateOutlet="cancel"></ng-container>
  <ng-container *ngTemplateOutlet="documents"></ng-container>
  } } }
</div>
<ng-template #documents let-onlyDocumentsMode="onlyDocumentsMode">
  <button
    mat-flat-button
    type="button"
    [disabled]="disabledActions || !showDocuments"
    (click)="handlePrintDocuments($event)"
  >
    <mat-icon>attachment</mat-icon>Documentos
  </button>
</ng-template>

<ng-template #cancel>
  <button
    mat-flat-button
    type="button"
    color="warn"
    [disabled]="disabledActions || cancelIsDisabled()"
    (click)="handleTransitionToCanceled($event)"
  >
    <mat-icon>clear</mat-icon>Anular
  </button>
</ng-template>
